import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AlreadySubmittedComponent } from './already-submitted/already-submitted.component';
import { CandidateAuthorizationComponent } from './candidate-authorization/candidate-authorization.component';
import { CandidateComponentDataEntryComponent } from './candidate-component-data-entry/candidate-component-data-entry.component';
import { CandidateDataEntryCompletionComponent } from './candidate-data-entry-completion/candidate-data-entry-completion.component';
import { CandidateLoginComponent } from './candidate-login/candidate-login.component';
import { CandidatePersonalDetailsComponent } from './candidate-personal-details/candidate-personal-details.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SidenavComponent } from './new-cde/sidenav/sidenav.component';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  // {path:'welcome',component:WelcomeComponent},
  // {path:'candidate/candidatepersonaldetails',component:CandidatePersonalDetailsComponent},
  // {path:'candidate/candidatecomponentdataentry',component:CandidateComponentDataEntryComponent},
  // {path:'candidate/authorization',component:CandidateAuthorizationComponent},
  {path:'login',component:CandidateLoginComponent},
  {path:'', component:SidenavComponent, canActivate:[AuthGuard]},
  {path:'candidate/candidatedataentrycompletion',component:CandidateDataEntryCompletionComponent},
  {path:'candidate/alreadysubmitted',component:AlreadySubmittedComponent},
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule {

 }
